import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-remote-therapeutic-monitoring',
  templateUrl: './public-remote-therapeutic-monitoring.component.html',
  styleUrls: ['./public-remote-therapeutic-monitoring.component.scss']
})
export class PublicRemoteTherapeuticMonitoringComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
